<template>
  <div>
    <editor  :init="tinymceInit" v-model="content" :key="tinymceFlag"></editor>
  </div>
</template>
<script>
const config = require('@/../vue.config');
import tinymce from 'tinymce/tinymce'
import Editor from '@tinymce/tinymce-vue'
import 'tinymce/themes/silver'
import 'tinymce/icons/default/icons'
import './import-all'
// import 'tinymce/themes/modern/theme'
import 'tinymce/themes/silver/theme'
export default {
  name: 'TinymceEditor',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    defaultContent: {
      type: String,
      default: '',
    },
    height: {
      type: Number,
      default: 500,
    },
    width: {
      type: Number,
      default: undefined,
    },
    upload_url: {
      type: String,
      default: '',
    },
    showMenubar: {
      type: Boolean,
      default: true,
    },
    toolbar: {
      type: String,
      default: `formatselect | fontselect | fontsizeselect
      | bold italic strikethrough underline
      | alignleft aligncenter alignright alignjustify lineheight outdent indent
      | removeformat cut copy paste blockquote subscript superscript table
      | forecolor backcolor link image media  
      | searchreplace charmap hr | undo redo | preview code fullscreen
      `,
      // {
        // undo （撤销）
        // redo （重做重复）
        // formatselect （段落格式）
        // bold （加粗）
        // italic （斜体）
        // strikethrough  （删除线）

        // alignleft （左对齐）
        // aligncenter （居中对齐）
        // alignright （右对齐）
        // alignjustify （两端对齐）
        // numlist （编号列表OL）
        // bullist （项目列表UL）
        // outdent （减少缩进）
        // indent （增加缩进）
        // removeformat （清除格式）
        // lineheight （行高 5.5新增）
        // newdocument （新文档）
        // underline （下划线）
        // styleselect （格式设置）
        // fontselect （字体选择）
        // fontsizeselect （字号选择）
        // cut （剪切）
        // copy （复制）
        // paste （粘贴）
        // blockquote （引用）
        // subscript （下角标）
        // superscript （上角标）
        // insertdatetime （时间）
        // table （表格）
        // forecolor backcolor formatpainter | link image  | preview fullscreen code
      // }
    },
  },
  components: {
    Editor,
  },
  data() {
    return {
      tinymceFlag: 1,
      tinymceInit: {},
      content: '',
      baseUrl:process.env.API_IMGURL,
    }
  },
  created() {
    const _this = this
    var language_url='../../../static/tinymce/langs/zh_CN.js';
    var skin_url='../../../static/tinymce/skins/ui/oxide';
    var content_css='../../../static/tinymce/skins/content/default/content.css';
    var node_env=process.env.NODE_ENV;
    if(node_env=='production'){
      language_url='../../..'+config.assetsPublicPath+'/static/tinymce/langs/zh_CN.js';
      skin_url='../../..'+config.assetsPublicPath+'/static/tinymce/skins/ui/oxide';
      content_css='../../..'+config.assetsPublicPath+'/static/tinymce/skins/content/default/content.css';
    }
    this.tinymceInit = {
      language_url:language_url,
      skin_url: skin_url,
      content_css: content_css,
      language: 'zh_CN',
      height: this.height,
      width: '100%',
      browser_spellcheck: true, // 拼写检查
      branding: false, // 去水印
      elementpath: false, // 禁用编辑器底部的状态栏
      statusbar: false, // 隐藏编辑器底部的状态栏
      paste_data_images: true, // 允许粘贴图像
      toolbar_mode:'wrap',
      toolbar_persist:true,
      convert_urls:false,
      // menubar: this.showMenubar, // 隐藏最上方 menu
      menubar: false, // 隐藏最上方 menu
      plugins: `link image preview fullscreen code searchreplace charmap hr media table`,
      // plugins: `print fullpage searchreplace autolink directionality visualblocks 
      // visualchars template codesample charmap hr pagebreak nonbreaking anchor toc insertdatetime 
      // wordcount textpattern help advlist table lists paste preview fullscreen image imagetools code link`,
      toolbar: this.toolbar,
      //   plugins:
      //     'print preview searchreplace autolink directionality visualblocks visualchars fullscreen image link media template code codesample table charmap hr pagebreak nonbreaking anchor insertdatetime advlist lists wordcount imagetools textpattern help emoticons autosave autoresize bdmap indent2em axupimgs',
      // toolbar: [
      //     'code undo redo restoredraft | cut copy paste pastetext | forecolor backcolor bold italic underline strikethrough link anchor | alignleft aligncenter alignright alignjustify outdent indent | \
      //  styleselect formatselect fontselect fontsizeselect | bullist numlist | blockquote subscript superscript removeformat | \
      //    table image media charmap emoticons hr pagebreak insertdatetime print preview | fullscreen | bdmap indent2em lineheight axupimgs'
      images_upload_handler(blobInfo, cb) {
        const file = new File([blobInfo.blob()], blobInfo.filename(), {type: 'image/*'});
        _this.uploadImg(file,(res)=>{
          cb(res)
        })
      },
      file_picker_callback(cb, value, meta){
        if(meta.filetype ==='media'||meta.filetype ==='image'){
          let input = document.createElement('input');
          input.setAttribute('type','file');
          if(meta.filetype ==='media'){
            input.setAttribute('accept','video/*');
          }else if(meta.filetype ==='image'){
            input.setAttribute('accept','image/*');
          }
          input.onchange = function(){
            let file = this.files[0];
            _this.uploadImg(file,(res)=>{
              cb(res)
            })
          }
          input.click();
        }
      }
    }
  },
  mounted() {
    if (this.defaultContent) {
      this.content = this.defaultContent
    }
  },
  methods: {
    uploadImg(file,cb){
      let formData = new FormData() 
      formData.append('file',file);
      formData.append('name','editor');
      this.$post('uploadImg',formData).then((res) => {
        cb(res.showname);
      })
    },
  },
  watch: {
    content: {
      handler() {
        this.$emit('change', this.content)
      },
    },
    defaultContent: {
      handler() {
        this.content = this.defaultContent
      },
      immediate: true,
    },
    value: {
      handler() {
        this.content = this.value
      },
      immediate: true,
    },
  },
  activated() {
    this.tinymceFlag++
  },
}
</script>
<style type="text/css">
.tox-silver-sink{
  z-index:3000!important;
}
.tox-toolbar__overflow{
  background-color:#fff!important;
}
p{
  margin:0;
}
</style>



// WEBPACK FOOTER //
// src/components/tinymce/index.vue